import React from 'react';
import { pageview } from '../../utils/googleAnalyticsUtils';

class ContactUs extends React.Component {

    componentDidMount(){
        pageview('Settings-Contact us');
    }

    render() {
        return (
            <div className='lead'>
                <p>Need help with something?</p>
                <p>Email us on <a href="mailto:info@meendutoons.com">info@meendutoons.com</a></p>
                <p>Contact us on : +91-7016977442</p>
            </div>
        )
    }
}

export default ContactUs